// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-37599fc8] .add-per-input {\n  margin-right: 10px;\n  width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  position: relative;\n  cursor: pointer;\n}\n[data-v-37599fc8] .add-per-input .el-icon-close {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
